$('input[type="radio"]').click(function () {
    const inputValue = $(this).attr("id");
    //console.log(inputValue)
    const targetBox = $("." + inputValue);
    //console.log(targetBox)
    $(".is-address-form-box").not(targetBox).hide();
    $(targetBox).show();
});
